<template>
    <ui-dropdown menu-class="p-3" v-if="loaded">
        <template #default="{ open, close, toggle }">
            <div class="flex flex-grow items-center cursor-pointer justify-center truncate"
                 @click="toggle" v-text="title"
            >
            </div>
        </template>
        <template #menu="{ close }" v-if="supportsDropdown">
            <div class="w-[23rem] h-auto bg-white p-0 text-gray-600" ref="slot1">
                <slot></slot>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import UiDropdown from "./ui/UiDropdown.vue";

export default {
    components: {UiDropdown},
    data() {
        return {
            loaded: false,
        }
    },
    props: {
        title: String,
        supportsDropdown: false,
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {
        this.$el.parentElement.childNodes.forEach((item) => {
            if (item !== this.$el) {
                this.$el.parentElement.removeChild(item)
            }
        })
        this.loaded = true;
        this.$nextTick(() => {
            this.$refs.slot1.childNodes[0].removeAttribute('style');
        })
    },
}
</script>
